import { useTranslation } from "react-i18next";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import CustomCurrencyFormat from "../utils/CurrencyFormat";
import iconsinfo from '../../assets/images/icons8-info-50.png';
import billTotal from "../utils/BillTotal";

import Orderdelivery from "../bill/Orderdelivery";

const OrderItem = (props) => {

  const targetRef = useRef();
  const { t } = useTranslation();
  const deliveryDate = new Date(props.delivery_date);
  const postDate = new Date(props.post_date);
  const today = new Date();

  const [isOrderActive, setIsOrderActive] = useState(false);



  const handleCloseOrderPopup = () => setIsOrderActive(false);
  const dollar = props.invoice?.dollars_spent ? parseFloat(props.invoice?.dollars_spent["$numberDecimal"]) : 0;

  const finalTotal = props.invoice
    ? billTotal(
      parseFloat(props.invoice?.inv_total["$numberDecimal"]),
      parseFloat(props.invoice?.shipping["$numberDecimal"]),
      parseFloat(props.invoice?.inv_discount["$numberDecimal"]),
      parseFloat(props.invoice?.customer_discount),
      dollar,
      parseFloat(props.tax["$numberDecimal"])
    )
    : parseFloat(props.total["$numberDecimal"]);

  const address = props?.deliveryaddress ?? props?.customer?.address;
  return (
    <div className="order-item">
      <h2>{address}</h2>

      <div className={"billitem_slides " + props.getStatusClass(props)}>
        <div className="billdate">
          <div className="billdate_data">
            <p>
              <span>{postDate.getDate()}</span>
              <span>
                {postDate.toLocaleString("en-US", { month: "short" })}
              </span>
              <span>{postDate.getFullYear()}</span>
            </p>
          </div>
          <div className="billdate_list">
            <div className="billdate_list_t">
              <div className="billdate_list_t_l">
                <div className="">{props.reference_no}</div>
                <h3>
                  <CustomCurrencyFormat
                    amount={finalTotal}
                  />
                </h3>
              </div>
              <div className="billdate_list_t_r">
                <span></span>
                <p>
                  {props.getStatus(props)} &nbsp;
                  {props.status == 4 && props?.invoice && today > deliveryDate && (
                    <>
                      {t("on")} {deliveryDate.getDate()} /{" "}
                      {deliveryDate.toLocaleString("en-US", {
                        month: "2-digit",
                      })}
                    </>
                  )}
                  {Number(props.status) === 9 && (
                    <div className="view_res-new"
                      onClick={() => {
                        if (props.reasonpopup) props.reasonpopup(props);
                      }}>
                      <img className="view_res" src={iconsinfo} alt="" width="18" height="18" />
                      <div className="viewreason_b">View Reason</div>
                    </div>
                  )}
                </p>
              </div>
            </div>
            <div className="billdate_list_b">
              {props.quotation && (
                <Link
                  to={`/quote/pdf/${props.quotation._id} `}
                  target="_blank"
                  className="view_quote"
                >
                  {t("view_quote")}
                </Link>
              )}
              {props.invoice && (
                <Link
                  to={`/invoice/pdf/${props.invoice._id} `}
                  target="_blank"
                  className="view_invoice"
                >
                  {t("view_invoice")}
                </Link>
              )}
              {!props.invoice && props.quotation && props.status != '8' && props.status != '9' && (
                <>
                  <button
                    className="reject_order"
                    onClick={() => props.reject(props.quotation._id)}
                  >
                    {t("reject")}
                  </button>

                  <button
                    className="approve_order"
                    onClick={() => props.approve(props.quotation._id)}
                  >
                    {t("approve_order")}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {props.reference_no && (
          <Orderdelivery
            isActive={isOrderActive}
            onClose={handleCloseOrderPopup}
            {...props}
          />
        )}
      </div>
    </div>
  );
};

export default OrderItem;
